type LastFunction = {
    <T>(array: T[]): T | undefined;
    (array: string): string | undefined;
};

export const last: LastFunction = <T>(array: T[] | string): T | string | undefined =>
    array?.[array.length - 1];
